import { createApp } from 'vue'
import Density from './Density.vue'
import './assets/global.css'

createApp(Density).mount('#density')
